module.exports = __webpack_public_path__ + "static/media/LogicWheel1_5_1.5bc37cb3.png";